module.exports = __webpack_public_path__ + "media/87.a73ad8fd.mp3";